import CachedIcon from '@mui/icons-material/Cached'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

export const highlightCards = [
  {
    id: 'optimize',
    Icon: CachedIcon,
    title: 'Optimize Workflow',
    textArray: [
      'Increase efficiency and throughput in your yard with our purchasing, inventory management, and sales modules.',
    ],
  },
  {
    id: 'save-time',
    Icon: AccessTimeIcon,
    title: 'Save Time & Money',
    textArray: [
      'Eliminate wasteful, paper-dominated steps in your process and free up your staff for more valuable work.',
    ],
  },
  {
    id: 'grow-faster',
    Icon: TrendingUpIcon,
    title: 'Grow Faster',
    textArray: ['Scale your business with powerful software that grows with you.'],
  },
]

export const keyFeaturesCards = [
  {
    id: 'intake',
    Icon: LocalShippingIcon,
    title: 'Intake',
    textArray: [
      'Clean and easy-to-use purchasing workflows',
      'Powerful customer and pricing management tools',
      'Tech enabled mobile devices for increased accuracy',
    ],
  },
  {
    id: 'inventory',
    Icon: AssignmentIcon,
    title: 'Inventory',
    textArray: [
      'Real time inventory tracking',
      'Integration with intake and sales modules',
      'Easily understand turnover analysis and commodity exposure',
    ],
  },
  {
    id: 'sales',
    Icon: AttachMoneyIcon,
    title: 'Sales',
    textArray: [
      'Standardize sales contracts',
      'Easily manage packing lists and bills of lading',
      'Streamlined invoicing and accounting integration',
    ],
  },
]
